<mat-accordion>
    <mat-expansion-panel (click)="clearFile('LoanAgreement')">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Loan Agreement
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionLoanAgreement">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'LoanAgreement')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>

            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="UploadDocument('LoanAgreement')">Submit</button>
        </div>
        <div *ngIf="dataSource.length > 0 && !uploadSectionLoanAgreement">
            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="showFileUploadSection('LoanAgreement')">Upload New File</button>
                
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="overflow: scroll;">
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                </ng-container>
                
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style="width: 15%;"> {{element.documentName}} </td>
                </ng-container>
                
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>
                
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" style="width: 20%;">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'LoanAgreement')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </mat-expansion-panel>

    <mat-expansion-panel (click)="clearFile('LoanOrignationFee')">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Remittance Notice
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionLoanOrignationFee">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'LoanOrignationFee')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>

            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="UploadDocument('LoanOrignationFee')">Submit</button>
        </div>
        <div *ngIf="dataSource.length > 0 && !uploadSectionLoanOrignationFee">
            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="showFileUploadSection('LoanOrignationFee')">Upload New File</button>
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="overflow: scroll;">
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                </ng-container>
                
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style="width: 15%;"> {{element.documentName}} </td>
                </ng-container>
                
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>
                
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" style="width: 20%;">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'LoanOrignationFee')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </mat-expansion-panel>

    <mat-expansion-panel (click)="clearFile('ApprovalLetter')">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Loan Approval Letter
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionApprovalLetter">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'ApprovalLetter')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>

            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="UploadDocument('ApprovalLetter')">Submit</button>
        </div>
        <div *ngIf="dataSource.length > 0 && !uploadSectionApprovalLetter">
            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="showFileUploadSection('ApprovalLetter')">Upload New File</button>
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="overflow: scroll;">
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                </ng-container>
                
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style="width: 15%;"> {{element.documentName}} </td>
                </ng-container>
                
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>
                
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" style="width: 20%;">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'ApprovalLetter')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </mat-expansion-panel>

    <mat-expansion-panel (click)="clearFile('CosignerLetter')">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Loan Cosigner Letter
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionCosignerLetter">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'CosignerLetter')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>

            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="UploadDocument('CosignerLetter')">Submit</button>
        </div>
        <div *ngIf="dataSource.length > 0 && !uploadSectionApprovalLetter">
            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="showFileUploadSection('CosignerLetter')">Upload New File</button>
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="overflow: scroll;">
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                </ng-container>
                
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style="width: 15%;"> {{element.documentName}} </td>
                </ng-container>
                
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>
                
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" style="width: 20%;">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'CosignerLetter')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </mat-expansion-panel>

    <mat-expansion-panel (click)="clearFile('LoanAch')">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Loan ACH Document
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div *ngIf="dataSource.length === 0 || uploadSectionLoanAch">
            <ngx-dropzone [accept]="acceptedFileTypes" (change)="onSelect($event, 'LoanAch')" [multiple]='true'>
                <ngx-dropzone-label>Drag or Drop your file</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [multiple]='false' [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
            </ngx-dropzone>

            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="UploadDocument('LoanAch')">Submit</button>
        </div>
        <div *ngIf="dataSource.length > 0 && !uploadSectionLoanAch">
            <button mat-flat-button [color]="'primary'" class="fuse-mat-button-large mt-3" style="margin-left: 0%;"
                (click)="showFileUploadSection('LoanAch')">Upload New File</button>
        </div>
        <div class="mt-8" *ngIf="dataSource.length > 0">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="overflow: scroll;">
                <ng-container matColumnDef="loanNumber">
                    <th mat-header-cell *matHeaderCellDef>Loan Number</th>
                    <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                </ng-container>
                
                <ng-container matColumnDef="documentName">
                    <th mat-header-cell *matHeaderCellDef>Document Name</th>
                    <td mat-cell *matCellDef="let element" style="width: 15%;"> {{element.documentName}} </td>
                </ng-container>
                
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef>Uploaded Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.lastUpdatedDateTime | date}} </td>
                </ng-container>
                
                <ng-container matColumnDef="download">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" style="width: 20%;">
                        <mat-icon style="cursor: pointer;" aria-hidden="false" aria-label="Example home icon"
                            matTooltip="Download" fontIcon="download" (click)="downloadDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="View" fontIcon="preview" (click)="previewDocument(element)"></mat-icon>

                        <mat-icon style="width: 25%; cursor: pointer;" aria-hidden="false" aria-label="view"
                            matTooltip="Delete" fontIcon="delete" (click)="onDeleteFile(element,'LoanAch')"></mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </div>
    </mat-expansion-panel>
</mat-accordion>